import React, { useState } from 'react'

import { StringParam, ArrayParam, useQueryParam, withDefault } from 'use-query-params'

export const sortFilters = ['mostPopular', 'a-z']
export const slotsCategoryFilterQuery = 'categories'
export const slotsProviderFilterQuery = 'providers'
export const slotsSortFilterQuery = 'sort'

const withQueryParams = (WrappedComponent: React.FC<any>) => (props: any) => {
  const [selectedProviders, setSelectedProviders] = useQueryParam(slotsProviderFilterQuery, withDefault(ArrayParam, []))
  const [selectedCategories, setSelectedCategories] = useQueryParam(
    slotsCategoryFilterQuery,
    withDefault(ArrayParam, ['all']),
  )
  const [selectedSort, setSelectedSort] = useQueryParam(slotsSortFilterQuery, withDefault(StringParam, sortFilters[0]))
  const [searchString, setSearchString] = useState('')

  return (
    <WrappedComponent
      {...props}
      filters={{
        selectedProviders,
        setSelectedProviders,
        selectedCategories,
        setSelectedCategories,
        searchString,
        setSearchString,
        selectedSort,
        setSelectedSort,
      }}
    />
  )
}

export default withQueryParams
